"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../axios-client/axios-client.service");
var insurances_const_1 = require("./insurances.const");
/**
 * InsurancesService
 * @class
 */
var InsurancesService = /** @class */ (function () {
    function InsurancesService() {
    }
    /**
     * Returns an array of insurances bound to a given user(`userUuid`)
     * @param userUuid {string}
     * @returns Insurance[]
     */
    InsurancesService.prototype.getIndex = function (userUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = insurances_const_1.INSURANCES_ENDPOINT.getIndex
            .replace('{{version}}', version)
            .replace('{{userUuid}}', userUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Adds a new insurance (`annualInsuranceUuid`) to a  given user(`userUuid`)
     * @param userUuid {string}
     * @param annualInsuranceUuid {string}
     */
    InsurancesService.prototype.postNewInsurance = function (userUuid, annualInsuranceUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = insurances_const_1.INSURANCES_ENDPOINT.postNewInsurance
            .replace('{{version}}', version)
            .replace('{{userUuid}}', userUuid)
            .replace('{{annualInsuranceUuid}}', annualInsuranceUuid);
        return axios_client_service_1.axiosClientInstance.post(url);
    };
    /**
     * Removes an insurance(`annualInsuranceUuid`) from a given user (`userUuid`)
     * @param userUuid {string}
     * @param annualInsuranceUuid {string}
     */
    InsurancesService.prototype.deleteAutorenewInsurance = function (userUuid, annualInsuranceUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = insurances_const_1.INSURANCES_ENDPOINT.deleteAutorenewInsurance
            .replace('{{version}}', version)
            .replace('{{userUuid}}', userUuid)
            .replace('{{annualInsuranceUuid}}', annualInsuranceUuid);
        return axios_client_service_1.axiosClientInstance.post(url);
    };
    return InsurancesService;
}());
/**
 * External InsurancesService Class Instance
 * @namespace
 */
exports.insurances = new InsurancesService();
